import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { statusToColor } from "./hd-status.service";

/** status 值 → 颜色，启动时构建一次 */
const STATUS_COLOR_MAP: Map<string, string> = (() => {
  const map = new Map<string, string>();
  for (const color of Object.keys(statusToColor)) {
    statusToColor[color].forEach((item) => {
      if (item) {
        map.set(item.toLowerCase(), color);
      }
    });
  }
  return map;
})();

@Component({
  selector: "hd-status",
  templateUrl: "./hd-status.component.html",
  styleUrls: ["./hd-status.component.less"],
})
export class HdStatusComponent implements OnInit, OnChanges {
  @Input() status: string;
  statusColor: string;

  constructor() {}

  ngOnInit() {
    this.setStatusColor();
  }

  ngOnChanges() {
    this.setStatusColor();
  }

  setStatusColor() {
    const statusLower = this.status && this.status.toLowerCase();
    this.statusColor =
      statusLower && STATUS_COLOR_MAP.has(statusLower)
        ? STATUS_COLOR_MAP.get(statusLower)
        : "#9FA4A2";
  }
}
